<template>
  <div class="out-wrap show-wrap">
    <Loadding ref="load" class="load-wrap" :submitInfo="info" />
    <h2>弘策科技——入职信息登记</h2>
    <baseinfo v-show="$route.query.page == 'base'" ref="baseInfo" />
    <educationinfo v-show="$route.query.page == 'education'" ref="educationInfo" />
    <employessinfo v-show="$route.query.page == 'employess'" @submitdata="submitData" ref="employessInfo" />
  </div>
</template>

<script>
import { request } from '../../utils/request';
import API from '../../utils/API';
import { getStore, setStore, removeStore } from '../../utils/localStore';
import Loadding from '../other/comp/load';
import baseinfo from './comp/base_info.vue';
import educationinfo from './comp/education_info.vue';
import employessinfo from './comp/employees_info.vue';
import moment from 'moment';

export default {
  data() {
    return {
      infoObj: {},
      interview_id: '',
      info: '信息获取中...',
    };
  },
  components: {
    Loadding,
    baseinfo,
    educationinfo,
    employessinfo,
  },
  mounted() {
    this.interview_id = this.$route.query.id;
    if (!this.interview_id) {
      this.$toast.fail('未知ID！');
      this.returnToConfirm();
      return;
    }
    if (this.$route.query.type == 'request') {
      this.$dialog
        .confirm({
          title: '入职信息填写',
          message: '欢迎加入弘策科技大家庭！信息内容较多，请仔细核对、填写...',
          confirmButtonText: '知道了',
          cancelButtonText: '取消',
        })
        .then(() => {
          this.getApplyInfo();
        })
        .catch(() => {
          this.returnToConfirm();
        });
    } else {
      let data = getStore({ name: 'applyInfo' });
      if (data) {
        this.$refs.baseInfo.baseInfoInit(data);
      } else {
        this.getApplyInfo();
      }
    }
  },
  methods: {
    async submitData() {
      let defaultObj = Object.assign(
        {},
        this.$refs.baseInfo.base_info,
        this.$refs.educationInfo.education_info,
        this.$refs.employessInfo.employees_info
      );
      //由于第一版设计者将花名册信息分为三张表，所以在前端将提交信息区分开（额为添加一张补充新表）
      let staffData = {},
        personal = {},
        personal_education = {},
        staff_supplement = {};
      //staff表的数据
      staffData = _.pick(defaultObj, ['name', 'phone', 'email', 'title']);
      //员工信息表的数据
      personal = _.pick(defaultObj, [
        'id_card_num',
        'sex',
        'born_time',
        'regist_address',
        'regist_type',
        'political_experience',
        'race',
        'marry',
        'contact_address',
        'qq',
        'phone',
        'emergency_contact',
        'emergency_phone',
        'emergency_relationship',
        'roommate_name',
        'roommate_phone',
        'bank_num',
      ]);
      //员工教育、工作经历相关的数据
      personal_education = Object.assign({}, { work: defaultObj.work, study: defaultObj.study });
      //获取剩余的字段
      let allAttr = Object.keys(defaultObj),
        haveSelectAttr = Object.keys(Object.assign({}, staffData, personal, personal_education));
      let tmp_staff_supplement = _.difference(allAttr, haveSelectAttr);
      _.map(tmp_staff_supplement, (item) => {
        //获取补充信息字段
        _.mapKeys(defaultObj, (value, key) => {
          if (item == key) {
            staff_supplement[key] = defaultObj[key];
          }
        });
      });
      //对特殊字段做处理
      personal.born_time = this.dateToTimestamp(personal.born_time);
      personal_education.work = JSON.stringify(personal_education.work);
      personal_education.study = JSON.stringify(personal_education.study);
      staff_supplement.ability = getStore({ name: 'joinBaseInfo' }).ability_id;
      staffData.ability = getStore({ name: 'joinBaseInfo' }).ability_id;
      this.info = '数据同步中...';
      this.$refs.load.openLoad();
      await request({
        method: 'post',
        url: API.PUT_JOIN_INFO,
        data: {
          staff_id: this.$route.query.staff_id,
          staffData,
          personal,
          personal_education,
          staff_supplement,
        },
      })
        .then((res) => {
          if (res.data.msg == 'success') {
            this.$toast.success({
              message: res.data.data.message,
            });
            this.$refs.load.closeLoad();
            setTimeout(() => {
              this.$router.push({
                path: '/submit_over',
                query: {
                  name: staffData.name + '-' + staffData.title,
                },
              });
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.load.closeLoad();
        });

      return;
      //提交万数据后  清除所有缓存
      removeStore({ name: 'applyInfo' });
      removeStore({ name: 'joinBaseInfo' });
      removeStore({ name: 'submitBaseInfo' });
      removeStore({ name: 'educationPageInfo' });
      removeStore({ name: 'employeesPageInfo' });
    },
    dateToTimestamp(dateStr) {
      if (!dateStr) {
        return '';
      }
      let newDataStr = new Date(dateStr);
      let timestamp = newDataStr.getTime() / 1000;
      return timestamp;
    },
    returnToConfirm() {
      this.$router.push({
        path: '/induction_confirm',
        query: {
          type: 'cancel',
        },
      });
    },
    async getApplyInfo() {
      this.$refs.load.openLoad();
      await request({
        method: 'get',
        url: API.GET_APPLY_INFO,
        data: {
          interview_id: this.interview_id,
        },
      })
        .then((data) => {
          let defaultData = data.data.data.list;
          if (defaultData.length !== 0) {
            setStore({
              name: 'applyInfo',
              content: defaultData[0],
              options: {
                expiry: '2h',
              },
            });
            this.infoObj = defaultData[0];
          }
          this.$refs.load.closeLoad();
        })
        .catch((err) => {
          this.$toast.fail('系统错误!');
          this.$refs.load.closeLoad();
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/page.css';
@import '../../assets/css/wrap.css';
.show-wrap {
  background: #f7f9fa;
  // background: #fbbf5c;
}
</style>
